import React, { Component } from "react";
import { Link } from "react-router-dom";
import $ from "jquery/dist/jquery.js";

import * as apiConstant from "../../../api/apiConstant";
import { Businesses } from "../../../config/Helper";
import { lang } from "../../../config/lang";
import { getVideoThumbFileName } from "../../../config/utils";
import { setTimeout } from "timers";
import logApi from "../../../api/logApi";
/****************************************
    Component for Testimony Block on Home Page
    @author  IMH003
    @date    2020.05.22
    @version 0.1    
 ******************************************/
class TestimonialBlock extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.waitAndEllipsis = this.waitAndEllipsis.bind(this);
    this.ellipsisStyle = this.ellipsisStyle.bind(this);
    this.onErrorImageLoad = this.onErrorImageLoad.bind(this);
  }

  componentWillMount() {}

  componentDidMount() {
    window.addEventListener("resize", this.waitAndEllipsis);
    // setTimeout(this.ellipsisStyle, 400);
  }

  componentDidUpdate() {
    setTimeout(this.ellipsisStyle, 400);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.waitAndEllipsis);
  }

  componentWillReceiveProps(newProps) {}

  waitAndEllipsis() {
    setTimeout(this.ellipsisStyle, 800);
  }

  ellipsisStyle() {
    window.ellipsisMe("#title_" + this.props.business + "_" + this.props.id);
    window.ellipsisMe("#desc_" + this.props.business + "_" + this.props.id);
  }

  onErrorImageLoad() {
    $("#img_" + this.props.business + "_" + this.props.id).attr(
      "src",
      "/assets/images/no_image.png"
    );
  }

  render() {
    var authorAndCountry =
      this.props.others === undefined || this.props.others === null
        ? ""
        : this.props.others.split(", ");
    var country =
      authorAndCountry === "" ||
      authorAndCountry[1] === "" ||
      authorAndCountry[1] === undefined
        ? ""
        : lang("author_from").replace("%country", authorAndCountry[1]);
    return (
      <div
        className="single-post-area experience col-md-6 col-lg-4 wow fadeInUp"
        data-wow-delay="300ms"
      >
        <div className="testimony text-center">
          <div>
            <Link
              to={`/blog/${Businesses[this.props.business]}/${this.props.id}`}
            >
              <span
                className="img-user"
                id={`img_${this.props.business}_${this.props.id}`}
                style={{
                  backgroundImage:
                    this.props.image === undefined || this.props.image === null
                      ? `url('/assets/images/no_image.png')`
                      : `url('${apiConstant.thumbnail(
                          this.props.business,
                          this.props.id,
                          this.props.media_type === 1
                            ? getVideoThumbFileName(this.props.image)
                            : this.props.image
                        )}')`,
                }}
              ></span>
            </Link>
            {this.props.media_type === 1 && (
              <a
                href={apiConstant.desktop(
                  this.props.business,
                  this.props.id,
                  this.props.image
                )}
                className="play-video video-icon small"
                style={{ marginLeft: "-16px" }}
                onClick={() =>
                  logApi.log({
                    title: this.props.title,
                    lang: localStorage.getItem("language"),
                    type: "동화상",
                  })
                }
              >
                <i className="fa fa-play" aria-hidden="true"></i>
              </a>
            )}
          </div>
          <Link
            to={`/blog/${Businesses[this.props.business]}/${this.props.id}`}
            id={`title_${this.props.business}_${this.props.id}`}
            className="post-title user ellipsis"
            caption={this.props.title}
            dangerouslySetInnerHTML={{ __html: this.props.title }}
          />
          <div className="testimony-author">
            <small className="author text-center" style={{ display: "block" }}>
              {authorAndCountry === "" ||
              authorAndCountry[0] === "" ||
              authorAndCountry[0] === undefined
                ? " "
                : authorAndCountry[0]}
            </small>
            <small className="country text-center" style={{ display: "block" }}>
              {country}
            </small>
          </div>
          <div className="text-left">
            <Link
              to={`/blog/${Businesses[this.props.business]}/${this.props.id}`}
              className="btn continue-btn"
            >
              <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default TestimonialBlock;
